// Auto-generated by scripts/generate-brand-directory.js — do not edit by hand.
// Regenerated on every `npm run build` (prebuild step) from live Supabase product data.
export const brandDirectory = [
  {
    "slug": "oribe",
    "name": "Oribe",
    "count": 239
  },
  {
    "slug": "sephora-collection",
    "name": "SEPHORA COLLECTION",
    "count": 233
  },
  {
    "slug": "moroccanoil",
    "name": "Moroccanoil",
    "count": 167
  },
  {
    "slug": "tarte",
    "name": "tarte",
    "count": 156
  },
  {
    "slug": "eminence-organic-skin-care",
    "name": "Eminence Organic Skin Care",
    "count": 146
  },
  {
    "slug": "dermalogica",
    "name": "Dermalogica",
    "count": 129
  },
  {
    "slug": "anastasia-beverly-hills",
    "name": "Anastasia Beverly Hills",
    "count": 123
  },
  {
    "slug": "kerastase",
    "name": "Kérastase",
    "count": 123
  },
  {
    "slug": "dior",
    "name": "Dior",
    "count": 122
  },
  {
    "slug": "la-roche-posay",
    "name": "La Roche-Posay",
    "count": 109
  },
  {
    "slug": "virtue",
    "name": "VIRTUE",
    "count": 108
  },
  {
    "slug": "davines",
    "name": "Davines",
    "count": 106
  },
  {
    "slug": "fenty-beauty-by-rihanna",
    "name": "Fenty Beauty by Rihanna",
    "count": 103
  },
  {
    "slug": "jane-iredale",
    "name": "jane iredale",
    "count": 98
  },
  {
    "slug": "bumble-and-bumble",
    "name": "Bumble and bumble",
    "count": 92
  },
  {
    "slug": "charlotte-tilbury",
    "name": "Charlotte Tilbury",
    "count": 86
  },
  {
    "slug": "yves-saint-laurent",
    "name": "Yves Saint Laurent",
    "count": 83
  },
  {
    "slug": "paula-s-choice",
    "name": "Paula's Choice",
    "count": 81
  },
  {
    "slug": "clinique",
    "name": "CLINIQUE",
    "count": 81
  },
  {
    "slug": "ouai",
    "name": "OUAI",
    "count": 79
  },
  {
    "slug": "dolce-and-gabbana",
    "name": "Dolce&Gabbana",
    "count": 78
  },
  {
    "slug": "amika",
    "name": "amika",
    "count": 77
  },
  {
    "slug": "benefit-cosmetics",
    "name": "Benefit Cosmetics",
    "count": 75
  },
  {
    "slug": "lancome",
    "name": "Lancôme",
    "count": 75
  },
  {
    "slug": "augustinus-bader",
    "name": "Augustinus Bader",
    "count": 74
  },
  {
    "slug": "supergoop",
    "name": "Supergoop!",
    "count": 74
  },
  {
    "slug": "phlur",
    "name": "PHLUR",
    "count": 71
  },
  {
    "slug": "skinceuticals",
    "name": "SkinCeuticals",
    "count": 70
  },
  {
    "slug": "sol-de-janeiro",
    "name": "Sol de Janeiro",
    "count": 67
  },
  {
    "slug": "tom-ford",
    "name": "TOM FORD",
    "count": 66
  },
  {
    "slug": "gucci",
    "name": "Gucci",
    "count": 66
  },
  {
    "slug": "sisley-paris",
    "name": "Sisley Paris",
    "count": 64
  },
  {
    "slug": "prada",
    "name": "Prada",
    "count": 64
  },
  {
    "slug": "drybar",
    "name": "Drybar",
    "count": 63
  },
  {
    "slug": "peter-thomas-roth",
    "name": "Peter Thomas Roth",
    "count": 62
  },
  {
    "slug": "pattern-by-tracee-ellis-ross",
    "name": "PATTERN by Tracee Ellis Ross",
    "count": 62
  },
  {
    "slug": "rare-beauty-by-selena-gomez",
    "name": "Rare Beauty by Selena Gomez",
    "count": 61
  },
  {
    "slug": "kayali",
    "name": "KAYALI",
    "count": 61
  },
  {
    "slug": "the-ordinary",
    "name": "The Ordinary",
    "count": 61
  },
  {
    "slug": "hourglass",
    "name": "Hourglass",
    "count": 59
  },
  {
    "slug": "murad",
    "name": "Murad",
    "count": 58
  },
  {
    "slug": "living-proof",
    "name": "Living Proof",
    "count": 58
  },
  {
    "slug": "igk",
    "name": "IGK",
    "count": 57
  },
  {
    "slug": "make-up-for-ever",
    "name": "MAKE UP FOR EVER",
    "count": 57
  },
  {
    "slug": "kiehl-s-since-1851",
    "name": "Kiehl's Since 1851",
    "count": 56
  },
  {
    "slug": "olaplex",
    "name": "Olaplex",
    "count": 55
  },
  {
    "slug": "glossier",
    "name": "Glossier",
    "count": 54
  },
  {
    "slug": "nest-new-york",
    "name": "NEST New York",
    "count": 54
  },
  {
    "slug": "armani-beauty",
    "name": "Armani Beauty",
    "count": 54
  },
  {
    "slug": "eltamd",
    "name": "EltaMD",
    "count": 53
  },
  {
    "slug": "versace",
    "name": "Versace",
    "count": 53
  },
  {
    "slug": "shu-uemura",
    "name": "shu uemura",
    "count": 53
  },
  {
    "slug": "obagi-medical",
    "name": "Obagi Medical",
    "count": 52
  },
  {
    "slug": "jo-malone-london",
    "name": "Jo Malone London",
    "count": 51
  },
  {
    "slug": "caudalie",
    "name": "Caudalie",
    "count": 51
  },
  {
    "slug": "u-beauty",
    "name": "U Beauty",
    "count": 50
  },
  {
    "slug": "first-aid-beauty",
    "name": "First Aid Beauty",
    "count": 50
  },
  {
    "slug": "briogeo",
    "name": "Briogeo",
    "count": 50
  },
  {
    "slug": "curlsmith",
    "name": "Curlsmith",
    "count": 50
  },
  {
    "slug": "kenra-professional",
    "name": "Kenra Professional",
    "count": 50
  },
  {
    "slug": "avene",
    "name": "Avène",
    "count": 49
  },
  {
    "slug": "pca-skin",
    "name": "PCA SKIN",
    "count": 49
  },
  {
    "slug": "dr-barbara-sturm",
    "name": "Dr. Barbara Sturm",
    "count": 49
  },
  {
    "slug": "sunday-riley",
    "name": "Sunday Riley",
    "count": 49
  },
  {
    "slug": "makeup-by-mario",
    "name": "MAKEUP BY MARIO",
    "count": 49
  },
  {
    "slug": "nars",
    "name": "NARS",
    "count": 49
  },
  {
    "slug": "urban-decay",
    "name": "Urban Decay",
    "count": 49
  },
  {
    "slug": "elemis",
    "name": "Elemis",
    "count": 48
  },
  {
    "slug": "colorescience",
    "name": "Colorescience",
    "count": 48
  },
  {
    "slug": "vacation",
    "name": "Vacation",
    "count": 48
  },
  {
    "slug": "espa",
    "name": "ESPA",
    "count": 48
  },
  {
    "slug": "pureology",
    "name": "Pureology",
    "count": 46
  },
  {
    "slug": "tatcha",
    "name": "Tatcha",
    "count": 46
  },
  {
    "slug": "color-wow",
    "name": "COLOR WOW",
    "count": 46
  },
  {
    "slug": "milk-makeup",
    "name": "MILK MAKEUP",
    "count": 46
  },
  {
    "slug": "cerave",
    "name": "CeraVe",
    "count": 45
  },
  {
    "slug": "unite-hair",
    "name": "UNITE Hair",
    "count": 45
  },
  {
    "slug": "rms-beauty",
    "name": "RMS Beauty",
    "count": 44
  },
  {
    "slug": "christophe-robin",
    "name": "Christophe Robin",
    "count": 43
  },
  {
    "slug": "medik8",
    "name": "Medik8",
    "count": 43
  },
  {
    "slug": "r-co",
    "name": "R+Co",
    "count": 43
  },
  {
    "slug": "is-clinical",
    "name": "iS Clinical",
    "count": 43
  },
  {
    "slug": "act-acre",
    "name": "Act+Acre",
    "count": 43
  },
  {
    "slug": "dr-jart",
    "name": "Dr. Jart+",
    "count": 43
  },
  {
    "slug": "drunk-elephant",
    "name": "Drunk Elephant",
    "count": 43
  },
  {
    "slug": "chanel",
    "name": "CHANEL",
    "count": 43
  },
  {
    "slug": "l-oreal-professionnel",
    "name": "L'Oréal Professionnel",
    "count": 43
  },
  {
    "slug": "valentino",
    "name": "Valentino",
    "count": 43
  },
  {
    "slug": "t3",
    "name": "T3",
    "count": 42
  },
  {
    "slug": "laneige",
    "name": "LANEIGE",
    "count": 42
  },
  {
    "slug": "jack-black",
    "name": "Jack Black",
    "count": 42
  },
  {
    "slug": "skinmedica",
    "name": "SkinMedica",
    "count": 41
  },
  {
    "slug": "mane",
    "name": "Mane",
    "count": 41
  },
  {
    "slug": "vegamour",
    "name": "Vegamour",
    "count": 41
  },
  {
    "slug": "necessaire",
    "name": "Nécessaire",
    "count": 41
  },
  {
    "slug": "bondiboost",
    "name": "BondiBoost",
    "count": 41
  },
  {
    "slug": "burberry",
    "name": "BURBERRY",
    "count": 40
  },
  {
    "slug": "ilia",
    "name": "ILIA",
    "count": 40
  },
  {
    "slug": "patrick-ta",
    "name": "PATRICK TA",
    "count": 40
  },
  {
    "slug": "crown-affair",
    "name": "Crown Affair",
    "count": 40
  },
  {
    "slug": "mac-cosmetics",
    "name": "MAC Cosmetics",
    "count": 40
  },
  {
    "slug": "westman-atelier",
    "name": "Westman Atelier",
    "count": 40
  },
  {
    "slug": "glow-recipe",
    "name": "Glow Recipe",
    "count": 40
  },
  {
    "slug": "the-inkey-list",
    "name": "The INKEY List",
    "count": 40
  },
  {
    "slug": "kevyn-aucoin",
    "name": "Kevyn Aucoin",
    "count": 39
  },
  {
    "slug": "olehenriksen",
    "name": "OLEHENRIKSEN",
    "count": 39
  },
  {
    "slug": "pat-mcgrath-labs",
    "name": "PAT McGRATH LABS",
    "count": 39
  },
  {
    "slug": "bioderma",
    "name": "Bioderma",
    "count": 38
  },
  {
    "slug": "revision-skincare",
    "name": "Revision Skincare",
    "count": 38
  },
  {
    "slug": "isdin",
    "name": "ISDIN",
    "count": 38
  },
  {
    "slug": "emi-jay",
    "name": "Emi Jay",
    "count": 38
  },
  {
    "slug": "fresh",
    "name": "fresh",
    "count": 38
  },
  {
    "slug": "too-faced",
    "name": "Too Faced",
    "count": 38
  },
  {
    "slug": "bobbi-brown",
    "name": "Bobbi Brown",
    "count": 38
  },
  {
    "slug": "glo-skin-beauty",
    "name": "Glo Skin Beauty",
    "count": 37
  },
  {
    "slug": "bareminerals",
    "name": "bareMinerals",
    "count": 37
  },
  {
    "slug": "kate-somerville",
    "name": "Kate Somerville",
    "count": 37
  },
  {
    "slug": "nudestix",
    "name": "NUDESTIX",
    "count": 37
  },
  {
    "slug": "chantecaille",
    "name": "Chantecaille",
    "count": 37
  },
  {
    "slug": "josie-maran",
    "name": "JOSIE MARAN",
    "count": 37
  },
  {
    "slug": "verb",
    "name": "Verb",
    "count": 37
  },
  {
    "slug": "cyklar",
    "name": "CYKLAR",
    "count": 37
  },
  {
    "slug": "natasha-denona",
    "name": "NATASHA DENONA",
    "count": 36
  },
  {
    "slug": "la-mer",
    "name": "La Mer",
    "count": 36
  },
  {
    "slug": "dr-dennis-gross",
    "name": "Dr Dennis Gross",
    "count": 35
  },
  {
    "slug": "laura-mercier",
    "name": "Laura Mercier",
    "count": 34
  },
  {
    "slug": "innisfree",
    "name": "innisfree",
    "count": 34
  },
  {
    "slug": "salt-and-stone",
    "name": "Salt & Stone",
    "count": 34
  },
  {
    "slug": "allies-of-skin",
    "name": "Allies of Skin",
    "count": 33
  },
  {
    "slug": "shiseido",
    "name": "Shiseido",
    "count": 33
  },
  {
    "slug": "summer-fridays",
    "name": "Summer Fridays",
    "count": 33
  },
  {
    "slug": "clarins",
    "name": "Clarins",
    "count": 33
  },
  {
    "slug": "huda-beauty",
    "name": "HUDA BEAUTY",
    "count": 33
  },
  {
    "slug": "dr-dennis-gross-skincare",
    "name": "Dr. Dennis Gross Skincare",
    "count": 33
  },
  {
    "slug": "vichy",
    "name": "Vichy",
    "count": 32
  },
  {
    "slug": "kosas",
    "name": "Kosas",
    "count": 32
  },
  {
    "slug": "slip",
    "name": "Slip",
    "count": 31
  },
  {
    "slug": "grande-cosmetics",
    "name": "GRANDE Cosmetics",
    "count": 31
  },
  {
    "slug": "sanitas-skincare",
    "name": "Sanitas Skincare",
    "count": 30
  },
  {
    "slug": "sk-ii",
    "name": "SK-II",
    "count": 30
  },
  {
    "slug": "pai",
    "name": "Pai",
    "count": 30
  },
  {
    "slug": "maison-louis-marie",
    "name": "Maison Louis Marie",
    "count": 30
  },
  {
    "slug": "saie",
    "name": "Saie",
    "count": 30
  },
  {
    "slug": "refy",
    "name": "REFY",
    "count": 30
  },
  {
    "slug": "sulwhasoo",
    "name": "Sulwhasoo",
    "count": 30
  },
  {
    "slug": "one-size-by-patrick-starrr",
    "name": "ONE/SIZE by Patrick Starrr",
    "count": 30
  },
  {
    "slug": "clean-reserve",
    "name": "CLEAN RESERVE",
    "count": 30
  },
  {
    "slug": "ellis-brooklyn",
    "name": "Ellis Brooklyn",
    "count": 30
  },
  {
    "slug": "sachajuan",
    "name": "Sachajuan",
    "count": 29
  },
  {
    "slug": "nuface",
    "name": "NuFACE",
    "count": 29
  },
  {
    "slug": "ghd",
    "name": "ghd",
    "count": 29
  },
  {
    "slug": "givenchy",
    "name": "Givenchy",
    "count": 29
  },
  {
    "slug": "carolina-herrera",
    "name": "Carolina Herrera",
    "count": 29
  },
  {
    "slug": "dae",
    "name": "dae",
    "count": 29
  },
  {
    "slug": "guerlain",
    "name": "GUERLAIN",
    "count": 29
  },
  {
    "slug": "l-occitane",
    "name": "L'Occitane",
    "count": 29
  },
  {
    "slug": "jean-paul-gaultier",
    "name": "Jean Paul Gaultier",
    "count": 29
  },
  {
    "slug": "dhc",
    "name": "DHC",
    "count": 28
  },
  {
    "slug": "natura-bisse",
    "name": "Natura Bissé",
    "count": 28
  },
  {
    "slug": "molton-brown",
    "name": "Molton Brown",
    "count": 28
  },
  {
    "slug": "juliette-has-a-gun",
    "name": "Juliette Has a Gun",
    "count": 28
  },
  {
    "slug": "skinfix",
    "name": "Skinfix",
    "count": 28
  },
  {
    "slug": "farmacy",
    "name": "Farmacy",
    "count": 28
  },
  {
    "slug": "st-tropez",
    "name": "St. Tropez",
    "count": 27
  },
  {
    "slug": "grown-alchemist",
    "name": "Grown Alchemist",
    "count": 27
  },
  {
    "slug": "naturopathica",
    "name": "Naturopathica",
    "count": 27
  },
  {
    "slug": "strivectin",
    "name": "StriVectin",
    "count": 27
  },
  {
    "slug": "dyson",
    "name": "Dyson",
    "count": 27
  },
  {
    "slug": "commodity",
    "name": "Commodity",
    "count": 27
  },
  {
    "slug": "maison-margiela",
    "name": "Maison Margiela",
    "count": 27
  },
  {
    "slug": "loveshackfancy",
    "name": "LoveShackFancy",
    "count": 27
  },
  {
    "slug": "perricone-md",
    "name": "Perricone MD",
    "count": 26
  },
  {
    "slug": "marc-jacobs-beauty",
    "name": "Marc Jacobs Beauty",
    "count": 26
  },
  {
    "slug": "mizani",
    "name": "Mizani",
    "count": 26
  },
  {
    "slug": "tower-28-beauty",
    "name": "Tower 28 Beauty",
    "count": 26
  },
  {
    "slug": "merit",
    "name": "MERIT",
    "count": 26
  },
  {
    "slug": "ouidad",
    "name": "Ouidad",
    "count": 26
  },
  {
    "slug": "kilian-paris",
    "name": "KILIAN Paris",
    "count": 26
  },
  {
    "slug": "gisou",
    "name": "Gisou",
    "count": 26
  },
  {
    "slug": "fable-and-mane",
    "name": "Fable & Mane",
    "count": 26
  },
  {
    "slug": "r-co-bleu",
    "name": "R+Co Bleu",
    "count": 25
  },
  {
    "slug": "leonor-greyl",
    "name": "Leonor Greyl",
    "count": 25
  },
  {
    "slug": "jan-marini",
    "name": "Jan Marini",
    "count": 25
  },
  {
    "slug": "miriam-quevedo",
    "name": "Miriam Quevedo",
    "count": 25
  },
  {
    "slug": "ursa-major",
    "name": "Ursa Major",
    "count": 25
  },
  {
    "slug": "philip-b",
    "name": "Philip B",
    "count": 25
  },
  {
    "slug": "replenix",
    "name": "Replenix",
    "count": 25
  },
  {
    "slug": "neom",
    "name": "NEOM",
    "count": 25
  },
  {
    "slug": "epicuren-discovery",
    "name": "Epicuren Discovery",
    "count": 25
  },
  {
    "slug": "clarityrx",
    "name": "ClarityRx",
    "count": 25
  },
  {
    "slug": "borntostandout",
    "name": "BORNTOSTANDOUT",
    "count": 25
  },
  {
    "slug": "viktor-and-rolf",
    "name": "Viktor&Rolf",
    "count": 25
  },
  {
    "slug": "seen",
    "name": "SEEN",
    "count": 24
  },
  {
    "slug": "philip-kingsley",
    "name": "Philip Kingsley",
    "count": 24
  },
  {
    "slug": "epionce",
    "name": "Epionce",
    "count": 24
  },
  {
    "slug": "phyto",
    "name": "Phyto",
    "count": 24
  },
  {
    "slug": "aesop",
    "name": "Aesop",
    "count": 24
  },
  {
    "slug": "higherdose",
    "name": "HigherDOSE",
    "count": 24
  },
  {
    "slug": "skylar",
    "name": "SKYLAR",
    "count": 24
  },
  {
    "slug": "rossano-ferretti-parma",
    "name": "Rossano Ferretti Parma",
    "count": 24
  },
  {
    "slug": "hermes",
    "name": "HERMÈS",
    "count": 24
  },
  {
    "slug": "estee-lauder",
    "name": "Estée Lauder",
    "count": 24
  },
  {
    "slug": "rabanne",
    "name": "Rabanne",
    "count": 24
  },
  {
    "slug": "jvn",
    "name": "JVN",
    "count": 24
  },
  {
    "slug": "ceremonia",
    "name": "Ceremonia",
    "count": 24
  },
  {
    "slug": "chunks",
    "name": "Chunks",
    "count": 24
  },
  {
    "slug": "erborian",
    "name": "Erborian",
    "count": 23
  },
  {
    "slug": "stila",
    "name": "Stila",
    "count": 23
  },
  {
    "slug": "neostrata",
    "name": "Neostrata",
    "count": 23
  },
  {
    "slug": "youth-to-the-people",
    "name": "Youth To The People",
    "count": 23
  },
  {
    "slug": "by-rosie-jane",
    "name": "By Rosie Jane",
    "count": 23
  },
  {
    "slug": "rhode",
    "name": "rhode",
    "count": 23
  },
  {
    "slug": "osmosis",
    "name": "Osmosis",
    "count": 22
  },
  {
    "slug": "mdsolarsciences",
    "name": "MDSolarSciences",
    "count": 22
  },
  {
    "slug": "yon-ka-paris-skincare",
    "name": "Yon-Ka Paris Skincare",
    "count": 22
  },
  {
    "slug": "montale",
    "name": "Montale",
    "count": 22
  },
  {
    "slug": "danessa-myricks-beauty",
    "name": "Danessa Myricks Beauty",
    "count": 22
  },
  {
    "slug": "biossance",
    "name": "Biossance",
    "count": 22
  },
  {
    "slug": "beauty-of-joseon",
    "name": "Beauty of Joseon",
    "count": 22
  },
  {
    "slug": "goop-beauty",
    "name": "goop beauty",
    "count": 21
  },
  {
    "slug": "revitalash",
    "name": "RevitaLash",
    "count": 21
  },
  {
    "slug": "rahua",
    "name": "Rahua",
    "count": 21
  },
  {
    "slug": "innbeauty-project",
    "name": "INNBEAUTY PROJECT",
    "count": 21
  },
  {
    "slug": "it-cosmetics",
    "name": "IT Cosmetics",
    "count": 21
  },
  {
    "slug": "dr-whitney-bowe-beauty",
    "name": "Dr. Whitney Bowe Beauty",
    "count": 20
  },
  {
    "slug": "by-terry",
    "name": "By Terry",
    "count": 20
  },
  {
    "slug": "image-skincare",
    "name": "IMAGE Skincare",
    "count": 20
  },
  {
    "slug": "exuviance",
    "name": "Exuviance",
    "count": 20
  },
  {
    "slug": "lancer-skincare",
    "name": "Lancer Skincare",
    "count": 20
  },
  {
    "slug": "boy-smells",
    "name": "Boy Smells",
    "count": 20
  },
  {
    "slug": "voluspa",
    "name": "VOLUSPA",
    "count": 20
  },
  {
    "slug": "violette-fr",
    "name": "VIOLETTE_FR",
    "count": 20
  },
  {
    "slug": "babylisspro",
    "name": "BaBylissPRO",
    "count": 20
  },
  {
    "slug": "agent-nateur",
    "name": "AGENT NATEUR",
    "count": 19
  },
  {
    "slug": "coola",
    "name": "COOLA",
    "count": 19
  },
  {
    "slug": "korres",
    "name": "KORRES",
    "count": 19
  },
  {
    "slug": "ameliorate",
    "name": "AMELIORATE",
    "count": 19
  },
  {
    "slug": "glytone",
    "name": "Glytone",
    "count": 19
  },
  {
    "slug": "iconic-london",
    "name": "Iconic London",
    "count": 19
  },
  {
    "slug": "the-7-virtues",
    "name": "The 7 Virtues",
    "count": 19
  },
  {
    "slug": "ranavat",
    "name": "RANAVAT",
    "count": 19
  },
  {
    "slug": "dedcool",
    "name": "DedCool",
    "count": 19
  },
  {
    "slug": "shark-beauty",
    "name": "Shark Beauty",
    "count": 19
  },
  {
    "slug": "alterna",
    "name": "Alterna",
    "count": 18
  },
  {
    "slug": "neocutis",
    "name": "Neocutis",
    "count": 18
  },
  {
    "slug": "hydropeptide",
    "name": "HydroPeptide",
    "count": 18
  },
  {
    "slug": "peace-out",
    "name": "Peace Out",
    "count": 18
  },
  {
    "slug": "adwoa-beauty",
    "name": "adwoa beauty",
    "count": 18
  },
  {
    "slug": "laura-geller",
    "name": "Laura Geller",
    "count": 18
  },
  {
    "slug": "origins",
    "name": "Origins",
    "count": 18
  },
  {
    "slug": "sarah-creal",
    "name": "Sarah Creal",
    "count": 18
  },
  {
    "slug": "this-works",
    "name": "this works",
    "count": 17
  },
  {
    "slug": "dphue",
    "name": "dpHUE",
    "count": 17
  },
  {
    "slug": "bioelements",
    "name": "Bioelements",
    "count": 17
  },
  {
    "slug": "weleda",
    "name": "Weleda",
    "count": 17
  },
  {
    "slug": "cosmedix",
    "name": "COSMEDIX",
    "count": 17
  },
  {
    "slug": "facile",
    "name": "facile",
    "count": 17
  },
  {
    "slug": "kora-organics",
    "name": "KORA Organics",
    "count": 17
  },
  {
    "slug": "caliray",
    "name": "caliray",
    "count": 17
  },
  {
    "slug": "jimmy-choo",
    "name": "JIMMY CHOO",
    "count": 17
  },
  {
    "slug": "henry-rose",
    "name": "Henry Rose",
    "count": 17
  },
  {
    "slug": "mara",
    "name": "MARA",
    "count": 17
  },
  {
    "slug": "ralph-lauren",
    "name": "Ralph Lauren",
    "count": 17
  },
  {
    "slug": "roz",
    "name": "RŌZ",
    "count": 16
  },
  {
    "slug": "lawless",
    "name": "LAWLESS",
    "count": 16
  },
  {
    "slug": "unove",
    "name": "UNOVE",
    "count": 16
  },
  {
    "slug": "haus-labs-by-lady-gaga",
    "name": "HAUS LABS BY LADY GAGA",
    "count": 16
  },
  {
    "slug": "tata-harper",
    "name": "Tata Harper",
    "count": 16
  },
  {
    "slug": "lys-beauty",
    "name": "LYS Beauty",
    "count": 16
  },
  {
    "slug": "beauty-ora",
    "name": "Beauty ORA",
    "count": 15
  },
  {
    "slug": "arcona",
    "name": "ARCONA",
    "count": 15
  },
  {
    "slug": "nulastin",
    "name": "NULASTIN",
    "count": 15
  },
  {
    "slug": "wander-beauty",
    "name": "Wander Beauty",
    "count": 15
  },
  {
    "slug": "dermablend",
    "name": "Dermablend",
    "count": 15
  },
  {
    "slug": "sephora-favorites",
    "name": "Sephora Favorites",
    "count": 15
  },
  {
    "slug": "k18-biomimetic-hairscience",
    "name": "K18 Biomimetic Hairscience",
    "count": 15
  },
  {
    "slug": "ciele",
    "name": "ciele",
    "count": 15
  },
  {
    "slug": "biodance",
    "name": "Biodance",
    "count": 15
  },
  {
    "slug": "isle-of-paradise",
    "name": "Isle of Paradise",
    "count": 15
  },
  {
    "slug": "isamaya",
    "name": "ISAMAYA",
    "count": 15
  },
  {
    "slug": "bioeffect",
    "name": "BIOEFFECT",
    "count": 14
  },
  {
    "slug": "therabody",
    "name": "Therabody",
    "count": 14
  },
  {
    "slug": "rejuvi",
    "name": "Rejuvi",
    "count": 14
  },
  {
    "slug": "shani-darden-skin-care",
    "name": "Shani Darden Skin Care",
    "count": 14
  },
  {
    "slug": "topicals",
    "name": "Topicals",
    "count": 14
  },
  {
    "slug": "velour-lashes",
    "name": "Velour Lashes",
    "count": 14
  },
  {
    "slug": "canopy",
    "name": "CANOPY",
    "count": 14
  },
  {
    "slug": "touchland",
    "name": "Touchland",
    "count": 14
  },
  {
    "slug": "brown-girl-jane",
    "name": "BROWN GIRL Jane",
    "count": 14
  },
  {
    "slug": "world-of-chris-collins",
    "name": "World of Chris Collins",
    "count": 14
  },
  {
    "slug": "messy-by-alli-webb",
    "name": "Messy by Alli Webb",
    "count": 14
  },
  {
    "slug": "ariana-grande",
    "name": "Ariana Grande",
    "count": 14
  },
  {
    "slug": "indie-lee",
    "name": "Indie Lee",
    "count": 13
  },
  {
    "slug": "koh-gen-do",
    "name": "Koh Gen Do",
    "count": 13
  },
  {
    "slug": "nette",
    "name": "Nette",
    "count": 13
  },
  {
    "slug": "sofie-pavitt-face",
    "name": "SOFIE PAVITT FACE",
    "count": 13
  },
  {
    "slug": "saint-jane-beauty",
    "name": "Saint Jane Beauty",
    "count": 13
  },
  {
    "slug": "chris-mcmillan",
    "name": "Chris McMillan",
    "count": 13
  },
  {
    "slug": "chloe",
    "name": "Chloé",
    "count": 13
  },
  {
    "slug": "mugler",
    "name": "Mugler",
    "count": 13
  },
  {
    "slug": "yise-beauty",
    "name": "YISE Beauty",
    "count": 13
  },
  {
    "slug": "the-maker",
    "name": "The Maker",
    "count": 13
  },
  {
    "slug": "bread-beauty-supply",
    "name": "BREAD BEAUTY SUPPLY",
    "count": 13
  },
  {
    "slug": "omorovicza",
    "name": "Omorovicza",
    "count": 12
  },
  {
    "slug": "kai",
    "name": "kai",
    "count": 12
  },
  {
    "slug": "fur",
    "name": "Fur",
    "count": 12
  },
  {
    "slug": "foria",
    "name": "Foria",
    "count": 12
  },
  {
    "slug": "evereden",
    "name": "Evereden",
    "count": 12
  },
  {
    "slug": "soft-services",
    "name": "Soft Services",
    "count": 12
  },
  {
    "slug": "damdam",
    "name": "DAMDAM",
    "count": 12
  },
  {
    "slug": "luna-daily",
    "name": "Luna Daily",
    "count": 12
  },
  {
    "slug": "fara-homidi",
    "name": "Fara Homidi",
    "count": 12
  },
  {
    "slug": "belif",
    "name": "belif",
    "count": 12
  },
  {
    "slug": "dolce-glow",
    "name": "Dolce Glow",
    "count": 12
  },
  {
    "slug": "forvr-mood",
    "name": "FORVR MOOD",
    "count": 12
  },
  {
    "slug": "akt-london",
    "name": "AKT London",
    "count": 12
  },
  {
    "slug": "dr-groot",
    "name": "Dr. Groot",
    "count": 12
  },
  {
    "slug": "hanyul",
    "name": "Hanyul",
    "count": 12
  },
  {
    "slug": "dr-loretta",
    "name": "Dr. Loretta",
    "count": 11
  },
  {
    "slug": "alpha-h",
    "name": "Alpha-H",
    "count": 11
  },
  {
    "slug": "susanne-kaufmann",
    "name": "SUSANNE KAUFMANN",
    "count": 11
  },
  {
    "slug": "luzern",
    "name": "Luzern",
    "count": 11
  },
  {
    "slug": "sienna-naturals",
    "name": "Sienna Naturals",
    "count": 11
  },
  {
    "slug": "bio-ionic",
    "name": "Bio Ionic",
    "count": 11
  },
  {
    "slug": "naturally-serious",
    "name": "Naturally Serious",
    "count": 11
  },
  {
    "slug": "dezi-skin",
    "name": "Dezi Skin",
    "count": 11
  },
  {
    "slug": "viori",
    "name": "Viori",
    "count": 11
  },
  {
    "slug": "eadem",
    "name": "EADEM",
    "count": 11
  },
  {
    "slug": "azzaro",
    "name": "Azzaro",
    "count": 11
  },
  {
    "slug": "dieux",
    "name": "Dieux",
    "count": 11
  },
  {
    "slug": "one-love-organics",
    "name": "One Love Organics",
    "count": 10
  },
  {
    "slug": "embryolisse",
    "name": "Embryolisse",
    "count": 10
  },
  {
    "slug": "rene-furterer",
    "name": "René Furterer",
    "count": 10
  },
  {
    "slug": "bask-suncare",
    "name": "Bask Suncare",
    "count": 10
  },
  {
    "slug": "holifrog",
    "name": "HoliFrog",
    "count": 10
  },
  {
    "slug": "marvis",
    "name": "Marvis",
    "count": 10
  },
  {
    "slug": "herbivore-botanicals",
    "name": "Herbivore Botanicals",
    "count": 10
  },
  {
    "slug": "biopelle",
    "name": "Biopelle",
    "count": 10
  },
  {
    "slug": "hugo-boss",
    "name": "Hugo Boss",
    "count": 10
  },
  {
    "slug": "shaz-and-kiks",
    "name": "SHAZ & KIKS",
    "count": 10
  },
  {
    "slug": "marc-jacobs-fragrances",
    "name": "Marc Jacobs Fragrances",
    "count": 10
  },
  {
    "slug": "dr-idriss",
    "name": "Dr. Idriss",
    "count": 10
  },
  {
    "slug": "iope",
    "name": "IOPE",
    "count": 10
  },
  {
    "slug": "inde-wild",
    "name": "indē wild",
    "count": 10
  },
  {
    "slug": "iris-and-romeo",
    "name": "Iris&Romeo",
    "count": 10
  },
  {
    "slug": "kate-mcleod",
    "name": "Kate McLeod",
    "count": 10
  },
  {
    "slug": "fenty-skin",
    "name": "Fenty Skin",
    "count": 10
  },
  {
    "slug": "kulfi",
    "name": "Kulfi",
    "count": 10
  },
  {
    "slug": "grow-gorgeous",
    "name": "Grow Gorgeous",
    "count": 9
  },
  {
    "slug": "sente",
    "name": "SENTÉ",
    "count": 9
  },
  {
    "slug": "skyn-iceland",
    "name": "skyn ICELAND",
    "count": 9
  },
  {
    "slug": "beautyblender",
    "name": "beautyblender",
    "count": 9
  },
  {
    "slug": "kypris",
    "name": "KYPRIS",
    "count": 9
  },
  {
    "slug": "african-botanics",
    "name": "African Botanics",
    "count": 9
  },
  {
    "slug": "element-eight",
    "name": "Element Eight",
    "count": 9
  },
  {
    "slug": "ebb-ocean-club",
    "name": "Ebb Ocean Club",
    "count": 9
  },
  {
    "slug": "aestura",
    "name": "AESTURA",
    "count": 9
  },
  {
    "slug": "lore",
    "name": "LORE",
    "count": 9
  },
  {
    "slug": "hung-vanngo-beauty",
    "name": "HUNG VANNGO BEAUTY",
    "count": 9
  },
  {
    "slug": "fugazzi",
    "name": "FUGAZZI",
    "count": 9
  },
  {
    "slug": "ogee",
    "name": "Ogee",
    "count": 9
  },
  {
    "slug": "ultra-violette",
    "name": "Ultra Violette",
    "count": 9
  },
  {
    "slug": "rejuran",
    "name": "Rejuran",
    "count": 9
  },
  {
    "slug": "klorane",
    "name": "KLORANE",
    "count": 8
  },
  {
    "slug": "furtuna-skin",
    "name": "Furtuna Skin",
    "count": 8
  },
  {
    "slug": "dr-diamond-s-metacine",
    "name": "Dr. Diamond's Metacine",
    "count": 8
  },
  {
    "slug": "sensica",
    "name": "Sensica",
    "count": 8
  },
  {
    "slug": "patchology",
    "name": "Patchology",
    "count": 8
  },
  {
    "slug": "revive",
    "name": "RéVive",
    "count": 8
  },
  {
    "slug": "jillian-dempsey",
    "name": "Jillian Dempsey",
    "count": 8
  },
  {
    "slug": "sonrei",
    "name": "Sonrei",
    "count": 8
  },
  {
    "slug": "doctor-rogers",
    "name": "Doctor Rogers",
    "count": 8
  },
  {
    "slug": "lilly-lashes",
    "name": "Lilly Lashes",
    "count": 8
  },
  {
    "slug": "kaja",
    "name": "Kaja",
    "count": 8
  },
  {
    "slug": "fig-1",
    "name": "Fig.1",
    "count": 8
  },
  {
    "slug": "lux-unfiltered",
    "name": "Lux Unfiltered",
    "count": 8
  },
  {
    "slug": "bounce-curl",
    "name": "Bounce Curl",
    "count": 8
  },
  {
    "slug": "miu-miu",
    "name": "Miu Miu",
    "count": 8
  },
  {
    "slug": "then-i-met-you",
    "name": "Then I Met You",
    "count": 8
  },
  {
    "slug": "ries",
    "name": "RIES",
    "count": 8
  },
  {
    "slug": "alpyn",
    "name": "ALPYN",
    "count": 8
  },
  {
    "slug": "torriden",
    "name": "Torriden",
    "count": 8
  },
  {
    "slug": "alterna-haircare",
    "name": "ALTERNA Haircare",
    "count": 8
  },
  {
    "slug": "dermaflash",
    "name": "DERMAFLASH",
    "count": 7
  },
  {
    "slug": "hero-cosmetics",
    "name": "Hero Cosmetics",
    "count": 7
  },
  {
    "slug": "shark",
    "name": "SHARK",
    "count": 7
  },
  {
    "slug": "glasshouse-fragrances",
    "name": "Glasshouse Fragrances",
    "count": 7
  },
  {
    "slug": "dr-brandt",
    "name": "Dr. Brandt",
    "count": 7
  },
  {
    "slug": "valmont",
    "name": "Valmont",
    "count": 7
  },
  {
    "slug": "manucurist",
    "name": "Manucurist",
    "count": 7
  },
  {
    "slug": "aavrani",
    "name": "AAVRANI",
    "count": 7
  },
  {
    "slug": "cay-skin",
    "name": "CAY SKIN",
    "count": 7
  },
  {
    "slug": "m-ph-by-mary-phillips",
    "name": "m.ph by Mary Phillips",
    "count": 7
  },
  {
    "slug": "sincerely-yours",
    "name": "Sincerely Yours",
    "count": 7
  },
  {
    "slug": "54-thrones",
    "name": "54 Thrones",
    "count": 7
  },
  {
    "slug": "harlem-perfume-co",
    "name": "Harlem Perfume Co.",
    "count": 7
  },
  {
    "slug": "hanni",
    "name": "Hanni",
    "count": 7
  },
  {
    "slug": "noble-panacea",
    "name": "Noble Panacea",
    "count": 6
  },
  {
    "slug": "evolvh",
    "name": "EVOLVh",
    "count": 6
  },
  {
    "slug": "suntegrity-skincare",
    "name": "Suntegrity Skincare",
    "count": 6
  },
  {
    "slug": "jenny-patinkin",
    "name": "Jenny Patinkin",
    "count": 6
  },
  {
    "slug": "anfisa-skin",
    "name": "ANFISA Skin",
    "count": 6
  },
  {
    "slug": "sweed",
    "name": "Sweed",
    "count": 6
  },
  {
    "slug": "cellex-c",
    "name": "Cellex-C",
    "count": 6
  },
  {
    "slug": "babor",
    "name": "BABOR",
    "count": 6
  },
  {
    "slug": "donna-karan",
    "name": "Donna Karan",
    "count": 6
  },
  {
    "slug": "tweezerman",
    "name": "TWEEZERMAN",
    "count": 6
  },
  {
    "slug": "ruhveda",
    "name": "RUHVEDA",
    "count": 6
  },
  {
    "slug": "paco-rabanne",
    "name": "Paco Rabanne",
    "count": 6
  },
  {
    "slug": "mango-people",
    "name": "Mango People",
    "count": 6
  },
  {
    "slug": "melanin-haircare",
    "name": "Melanin Haircare",
    "count": 6
  },
  {
    "slug": "montblanc",
    "name": "Montblanc",
    "count": 6
  },
  {
    "slug": "experiment",
    "name": "Experiment",
    "count": 6
  },
  {
    "slug": "beauty-insider",
    "name": "BEAUTY INSIDER",
    "count": 6
  },
  {
    "slug": "eilish-fragrances",
    "name": "EILISH FRAGRANCES",
    "count": 6
  },
  {
    "slug": "the-steam-bar",
    "name": "THE STEAM BAR",
    "count": 6
  },
  {
    "slug": "arencia",
    "name": "Arencia",
    "count": 6
  },
  {
    "slug": "freck-beauty",
    "name": "Freck Beauty",
    "count": 6
  },
  {
    "slug": "jupiter",
    "name": "Jupiter",
    "count": 5
  },
  {
    "slug": "charlotte-mensah",
    "name": "Charlotte Mensah",
    "count": 5
  },
  {
    "slug": "verso",
    "name": "VERSO",
    "count": 5
  },
  {
    "slug": "111skin",
    "name": "111SKIN",
    "count": 5
  },
  {
    "slug": "rapidlash",
    "name": "RapidLash",
    "count": 5
  },
  {
    "slug": "beautyfix",
    "name": "BeautyFIX",
    "count": 5
  },
  {
    "slug": "eve-lom",
    "name": "Eve Lom",
    "count": 5
  },
  {
    "slug": "dune-suncare",
    "name": "Dune Suncare",
    "count": 5
  },
  {
    "slug": "skin-design-london",
    "name": "Skin Design London",
    "count": 5
  },
  {
    "slug": "coach",
    "name": "COACH",
    "count": 5
  },
  {
    "slug": "banu",
    "name": "banu",
    "count": 5
  },
  {
    "slug": "kvd-beauty",
    "name": "KVD Beauty",
    "count": 5
  },
  {
    "slug": "alpyn-beauty",
    "name": "alpyn beauty",
    "count": 5
  },
  {
    "slug": "skin-gym",
    "name": "Skin Gym",
    "count": 4
  },
  {
    "slug": "lyma",
    "name": "LYMA",
    "count": 4
  },
  {
    "slug": "lashfood",
    "name": "LashFood",
    "count": 4
  },
  {
    "slug": "vi-derm",
    "name": "VI Derm",
    "count": 4
  },
  {
    "slug": "foreo",
    "name": "FOREO",
    "count": 4
  },
  {
    "slug": "mason-pearson",
    "name": "Mason Pearson",
    "count": 4
  },
  {
    "slug": "oxygenetix",
    "name": "Oxygenetix",
    "count": 4
  },
  {
    "slug": "plume-science",
    "name": "Plume Science",
    "count": 4
  },
  {
    "slug": "venn-skincare",
    "name": "VENN Skincare",
    "count": 4
  },
  {
    "slug": "irene-forte-skincare",
    "name": "Irene Forte Skincare",
    "count": 4
  },
  {
    "slug": "guinot",
    "name": "Guinot",
    "count": 4
  },
  {
    "slug": "dermstore-bundles",
    "name": "Dermstore Bundles",
    "count": 4
  },
  {
    "slug": "lelo",
    "name": "LELO",
    "count": 4
  },
  {
    "slug": "lixr-beauty",
    "name": "LIXR Beauty",
    "count": 4
  },
  {
    "slug": "basma",
    "name": "BASMA",
    "count": 4
  },
  {
    "slug": "glamnetic",
    "name": "Glamnetic",
    "count": 4
  },
  {
    "slug": "maude",
    "name": "maude",
    "count": 4
  },
  {
    "slug": "maed",
    "name": "MAED",
    "count": 4
  },
  {
    "slug": "phyla",
    "name": "PHYLA",
    "count": 4
  },
  {
    "slug": "rose-ingleton-md",
    "name": "ROSE Ingleton MD",
    "count": 4
  },
  {
    "slug": "laka",
    "name": "Laka",
    "count": 4
  },
  {
    "slug": "range-beauty",
    "name": "Range Beauty",
    "count": 4
  },
  {
    "slug": "oliviaumma",
    "name": "OLIVIAUMMA",
    "count": 4
  },
  {
    "slug": "sephora-the-merch-shop",
    "name": "SEPHORA The Merch Shop",
    "count": 4
  },
  {
    "slug": "oui-the-people",
    "name": "OUI the People",
    "count": 4
  },
  {
    "slug": "angela-caglia",
    "name": "Angela Caglia",
    "count": 3
  },
  {
    "slug": "neulash",
    "name": "neuLash",
    "count": 3
  },
  {
    "slug": "the-nue-co",
    "name": "The Nue Co.",
    "count": 3
  },
  {
    "slug": "mz-skin",
    "name": "MZ Skin",
    "count": 3
  },
  {
    "slug": "pmd",
    "name": "PMD",
    "count": 3
  },
  {
    "slug": "melt-cosmetics",
    "name": "Melt Cosmetics",
    "count": 3
  },
  {
    "slug": "5-sens",
    "name": "5 SENS",
    "count": 3
  },
  {
    "slug": "lion-pose",
    "name": "Lion Pose",
    "count": 3
  },
  {
    "slug": "cinema-secrets",
    "name": "Cinema Secrets",
    "count": 3
  },
  {
    "slug": "simihaze-beauty",
    "name": "SIMIHAZE BEAUTY",
    "count": 3
  },
  {
    "slug": "stripes",
    "name": "Stripes",
    "count": 3
  },
  {
    "slug": "ami-cole",
    "name": "Ami Colé",
    "count": 3
  },
  {
    "slug": "katini-skin",
    "name": "Katini Skin",
    "count": 3
  },
  {
    "slug": "lightstim",
    "name": "LightStim",
    "count": 2
  },
  {
    "slug": "best-of-dermstore",
    "name": "Best of Dermstore",
    "count": 2
  },
  {
    "slug": "david-mallett",
    "name": "David Mallett",
    "count": 2
  },
  {
    "slug": "daniel-sandler",
    "name": "Daniel Sandler",
    "count": 2
  },
  {
    "slug": "cosrx",
    "name": "COSRX",
    "count": 2
  },
  {
    "slug": "wellbel",
    "name": "Wellbel",
    "count": 2
  },
  {
    "slug": "beautystat",
    "name": "BeautyStat",
    "count": 2
  },
  {
    "slug": "sunday-ii-sunday",
    "name": "SUNDAY II SUNDAY",
    "count": 2
  },
  {
    "slug": "luna-da",
    "name": "Luna Da",
    "count": 2
  },
  {
    "slug": "the-original-makeup-eraser",
    "name": "The Original MakeUp Eraser",
    "count": 2
  },
  {
    "slug": "luna",
    "name": "Luna",
    "count": 2
  },
  {
    "slug": "dr",
    "name": "Dr.",
    "count": 2
  },
  {
    "slug": "innbeauty-projec",
    "name": "INNBEAUTY PROJEC",
    "count": 2
  },
  {
    "slug": "peter-thomas",
    "name": "Peter Thomas",
    "count": 2
  },
  {
    "slug": "josie-mara",
    "name": "JOSIE MARA",
    "count": 2
  },
  {
    "slug": "biodan",
    "name": "Biodan",
    "count": 2
  },
  {
    "slug": "necess",
    "name": "Nécess",
    "count": 2
  },
  {
    "slug": "wonderskin",
    "name": "Wonderskin",
    "count": 2
  },
  {
    "slug": "youth-to",
    "name": "Youth To",
    "count": 2
  },
  {
    "slug": "mother-science",
    "name": "Mother Science",
    "count": 2
  },
  {
    "slug": "peter-t",
    "name": "Peter T",
    "count": 2
  },
  {
    "slug": "roen",
    "name": "RÓEN",
    "count": 1
  },
  {
    "slug": "neurae",
    "name": "Neuraé",
    "count": 1
  },
  {
    "slug": "olga-lorencin-skin-care",
    "name": "Olga Lorencin Skin Care",
    "count": 1
  },
  {
    "slug": "deesse-pro",
    "name": "Déesse Pro",
    "count": 1
  },
  {
    "slug": "yves-durif",
    "name": "Yves Durif",
    "count": 1
  },
  {
    "slug": "dame",
    "name": "Dame",
    "count": 1
  },
  {
    "slug": "the-light-salon",
    "name": "The Light Salon",
    "count": 1
  },
  {
    "slug": "soleil-toujours",
    "name": "Soleil Toujours",
    "count": 1
  },
  {
    "slug": "emepelle",
    "name": "Emepelle",
    "count": 1
  },
  {
    "slug": "nurse-jamie",
    "name": "Nurse Jamie",
    "count": 1
  },
  {
    "slug": "f",
    "name": "F",
    "count": 1
  },
  {
    "slug": "fenty-beauty-by-rihann",
    "name": "Fenty Beauty by Rihann",
    "count": 1
  },
  {
    "slug": "estee-laud",
    "name": "Estée Laud",
    "count": 1
  },
  {
    "slug": "ne",
    "name": "Né",
    "count": 1
  },
  {
    "slug": "aestur",
    "name": "AESTUR",
    "count": 1
  },
  {
    "slug": "sarah-crea",
    "name": "Sarah Crea",
    "count": 1
  },
  {
    "slug": "erboria",
    "name": "Erboria",
    "count": 1
  },
  {
    "slug": "paula-s-choic",
    "name": "Paula's Choic",
    "count": 1
  },
  {
    "slug": "lu",
    "name": "Lu",
    "count": 1
  },
  {
    "slug": "b-pricing",
    "name": "B PRICING",
    "count": 1
  },
  {
    "slug": "the-ordina",
    "name": "The Ordina",
    "count": 1
  },
  {
    "slug": "nourishing-treatment-cleanse-with-lipid-rich-oils-niacinamide-with-pump",
    "name": "Nourishing Treatment Cleanse With Lipid-Rich Oils + Niacinamide With Pump",
    "count": 1
  },
  {
    "slug": "fenty-s",
    "name": "Fenty S",
    "count": 1
  },
  {
    "slug": "rare-beauty-by-selena",
    "name": "Rare Beauty by Selena",
    "count": 1
  },
  {
    "slug": "necessair",
    "name": "Nécessair",
    "count": 1
  },
  {
    "slug": "sephora-collec",
    "name": "SEPHORA COLLEC",
    "count": 1
  },
  {
    "slug": "kate-somervill",
    "name": "Kate Somervill",
    "count": 1
  },
  {
    "slug": "danessa-myricks",
    "name": "Danessa Myricks",
    "count": 1
  },
  {
    "slug": "valentin",
    "name": "Valentin",
    "count": 1
  },
  {
    "slug": "non-stripping-with-shea-butter-ceramides-and-niacinamide",
    "name": "Non-Stripping with Shea Butter, Ceramides and Niacinamide",
    "count": 1
  },
  {
    "slug": "ranav",
    "name": "RANAV",
    "count": 1
  },
  {
    "slug": "natasha",
    "name": "NATASHA",
    "count": 1
  },
  {
    "slug": "oliviaum",
    "name": "OLIVIAUM",
    "count": 1
  },
  {
    "slug": "olivi",
    "name": "OLIVI",
    "count": 1
  },
  {
    "slug": "youth",
    "name": "Youth",
    "count": 1
  },
  {
    "slug": "dr-i",
    "name": "Dr. I",
    "count": 1
  },
  {
    "slug": "sephora",
    "name": "SEPHORA",
    "count": 1
  },
  {
    "slug": "innbeauty-proj",
    "name": "INNBEAUTY PROJ",
    "count": 1
  },
  {
    "slug": "marc-jacobs-bea",
    "name": "Marc Jacobs Bea",
    "count": 1
  },
  {
    "slug": "superzero",
    "name": "superzero",
    "count": 1
  },
  {
    "slug": "dr-dennis-gross-s",
    "name": "Dr. Dennis Gross S",
    "count": 1
  },
  {
    "slug": "dr-barbara",
    "name": "Dr. Barbara",
    "count": 1
  },
  {
    "slug": "charlotte-ti",
    "name": "Charlotte Ti",
    "count": 1
  },
  {
    "slug": "rare-beauty-by-selena-go",
    "name": "Rare Beauty by Selena Go",
    "count": 1
  },
  {
    "slug": "kiehl-s-sin",
    "name": "Kiehl's Sin",
    "count": 1
  },
  {
    "slug": "sof",
    "name": "Sof",
    "count": 1
  },
  {
    "slug": "duo",
    "name": "DUO",
    "count": 1
  },
  {
    "slug": "glow",
    "name": "Glow",
    "count": 1
  },
  {
    "slug": "maiso",
    "name": "Maiso",
    "count": 1
  },
  {
    "slug": "ori",
    "name": "Ori",
    "count": 1
  },
  {
    "slug": "daness",
    "name": "Daness",
    "count": 1
  },
  {
    "slug": "fel-beauty",
    "name": "fel beauty",
    "count": 1
  },
  {
    "slug": "pete",
    "name": "Pete",
    "count": 1
  },
  {
    "slug": "marc-jacobs-beaut",
    "name": "Marc Jacobs Beaut",
    "count": 1
  },
  {
    "slug": "then-i-met",
    "name": "Then I Met",
    "count": 1
  },
  {
    "slug": "necessai",
    "name": "Nécessai",
    "count": 1
  },
  {
    "slug": "aren",
    "name": "Aren",
    "count": 1
  },
  {
    "slug": "maison-ma",
    "name": "Maison Ma",
    "count": 1
  },
  {
    "slug": "aes",
    "name": "AES",
    "count": 1
  },
  {
    "slug": "pet",
    "name": "Pet",
    "count": 1
  },
  {
    "slug": "mother-sc",
    "name": "Mother Sc",
    "count": 1
  },
  {
    "slug": "natasha-denon",
    "name": "NATASHA DENON",
    "count": 1
  },
  {
    "slug": "silicone-fre",
    "name": "Silicone Fre",
    "count": 1
  },
  {
    "slug": "yves-saint-lauren",
    "name": "Yves Saint Lauren",
    "count": 1
  },
  {
    "slug": "fenty-beauty-by-rih",
    "name": "Fenty Beauty by Rih",
    "count": 1
  },
  {
    "slug": "dr-dennis-gross-skin",
    "name": "Dr. Dennis Gross Skin",
    "count": 1
  },
  {
    "slug": "youth-to-the-peop",
    "name": "Youth To The Peop",
    "count": 1
  },
  {
    "slug": "danessa-myricks-beau",
    "name": "Danessa Myricks Beau",
    "count": 1
  },
  {
    "slug": "54",
    "name": "54",
    "count": 1
  },
  {
    "slug": "armani-bea",
    "name": "Armani Bea",
    "count": 1
  },
  {
    "slug": "aest",
    "name": "AEST",
    "count": 1
  },
  {
    "slug": "yves-saint-la",
    "name": "Yves Saint La",
    "count": 1
  },
  {
    "slug": "katini",
    "name": "Katini",
    "count": 1
  },
  {
    "slug": "house-of-lashes",
    "name": "House of Lashes",
    "count": 1
  },
  {
    "slug": "kerastas",
    "name": "Kérastas",
    "count": 1
  },
  {
    "slug": "dolce-and-gabban",
    "name": "Dolce&Gabban",
    "count": 1
  },
  {
    "slug": "dr-dennis-gross-ski",
    "name": "Dr. Dennis Gross Ski",
    "count": 1
  },
  {
    "slug": "brioge",
    "name": "Brioge",
    "count": 1
  },
  {
    "slug": "everede",
    "name": "Everede",
    "count": 1
  },
  {
    "slug": "kera",
    "name": "Kéra",
    "count": 1
  },
  {
    "slug": "element-eig",
    "name": "Element Eig",
    "count": 1
  },
  {
    "slug": "extra-strength-natural-non-staining-aluminum-free-body-de",
    "name": "Extra-strength, Natural, Non-Staining, Aluminum Free Body De",
    "count": 1
  },
  {
    "slug": "kiehl-s-since-18",
    "name": "Kiehl's Since 18",
    "count": 1
  },
  {
    "slug": "you",
    "name": "You",
    "count": 1
  },
  {
    "slug": "der",
    "name": "Der",
    "count": 1
  },
  {
    "slug": "youth-to-the-peo",
    "name": "Youth To The Peo",
    "count": 1
  },
  {
    "slug": "dr-dennis-gross-skinc",
    "name": "Dr. Dennis Gross Skinc",
    "count": 1
  },
  {
    "slug": "dr-jar",
    "name": "Dr. Jar",
    "count": 1
  },
  {
    "slug": "make-up-for",
    "name": "MAKE UP FOR",
    "count": 1
  },
  {
    "slug": "laura-g",
    "name": "Laura G",
    "count": 1
  }
];
